import { useState } from "react";
import { Cloud, Building2, Receipt, Landmark, Calculator, Smartphone, BarChart3 } from "lucide-react";

const NODES = [
  { icon: Building2, label: "Gestión empresarial", desc: "Sistemas a la medida que centralizan la operación diaria de su organización.", x: 50, y: 8 },
  { icon: Receipt, label: "Facturación electrónica", desc: "Emisión y automatización de comprobantes electrónicos.", x: 88, y: 30 },
  { icon: Landmark, label: "Aduanas y gobierno", desc: "Integración con plataformas gubernamentales y de aduanas.", x: 88, y: 70 },
  { icon: Calculator, label: "Sistemas contables", desc: "Sincronización con sistemas contables y administrativos.", x: 50, y: 92 },
  { icon: Smartphone, label: "Apps móviles", desc: "Operación en campo con aplicaciones Android e iOS.", x: 12, y: 70 },
  { icon: BarChart3, label: "Analítica", desc: "Información consolidada para decisiones operativas.", x: 12, y: 30 },
];

export function HeroDiagram() {
  const [active, setActive] = useState(0);
  const node = NODES[active];
  return (
    <div className="relative mx-auto w-full max-w-[520px]" data-testid="hero-diagram">
      <div className="relative aspect-square">
        <svg viewBox="0 0 100 100" className="absolute inset-0 h-full w-full" aria-hidden="true">
          <circle cx="50" cy="50" r="30" fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth="0.3" />
          <circle cx="50" cy="50" r="42" fill="none" stroke="rgba(255,255,255,0.05)" strokeWidth="0.3" strokeDasharray="1 2" />
          {NODES.map((n, i) => (
            <line key={n.label} x1="50" y1="50" x2={n.x} y2={n.y} className="flow-line" strokeWidth={i === active ? 0.6 : 0.3}
              stroke={i === active ? "var(--cc-accent)" : "rgba(148,163,184,0.45)"} style={{ animationDelay: `${i * 0.2}s` }} />
          ))}
        </svg>
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
          <span className="pulse-ring absolute inset-0 rounded-3xl border border-[color:var(--cc-accent)]" />
          <div className="relative grid h-24 w-24 place-items-center rounded-3xl bg-brand shadow-2xl shadow-blue-900/50 sm:h-28 sm:w-28">
            <Cloud className="h-10 w-10 text-white" />
            <span className="absolute -bottom-7 whitespace-nowrap font-mono text-[10px] uppercase tracking-[0.25em] text-slate-400">Cloud core</span>
          </div>
        </div>
        {NODES.map((n, i) => (
          <button key={n.label} onMouseEnter={() => setActive(i)} onFocus={() => setActive(i)} onClick={() => setActive(i)}
            data-testid={`hero-node-${i}`} aria-label={n.label} style={{ left: `${n.x}%`, top: `${n.y}%` }}
            className={`absolute -translate-x-1/2 -translate-y-1/2 grid h-12 w-12 place-items-center rounded-2xl border backdrop-blur-md transition-[transform,background-color,border-color] duration-300 sm:h-14 sm:w-14 ${
              i === active ? "scale-110 border-[color:var(--cc-accent)] bg-white/15" : "border-white/15 bg-white/5 hover:bg-white/10"}`}>
            <n.icon className={`h-5 w-5 ${i === active ? "text-signal" : "text-slate-300"}`} />
          </button>
        ))}
      </div>
      <div className="mt-6 rounded-2xl border border-white/10 bg-white/5 p-5 backdrop-blur-xl" data-testid="hero-node-detail" aria-live="polite">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-signal">Integración · {String(active + 1).padStart(2, "0")}</p>
        <p className="mt-1 font-display text-lg font-semibold text-white">{node.label}</p>
        <p className="mt-1 text-sm text-slate-400">{node.desc}</p>
      </div>
    </div>
  );
}
